import { useContext, useState } from 'react';
import { IconButton } from '../';
import { AppContext } from '../../providers/AppContext';
import { StyledLogoutModal } from './LogoutModal.styled';
import { passportInstance, composeShortAddress } from '../../utils'; 
import { useDisconnect, useAccount } from 'wagmi';
import { useNavigate, useLocation } from "react-router-dom";
import { useTokenAuth } from '../../hooks';
import { useWeb3Modal } from '@web3modal/wagmi/react';
import { useConnection, useActiveAddress } from "arweave-wallet-kit";
import { removeUserWallets } from '../../providers/BasejumpApiProvider';
import { useConnect } from 'wagmi';
import { theme } from '../../theme';

const LogoutTitle = () => {
  return (
    <div className='logout-modal-title-holder'>
      <div className='logout-modal-title-stub-short' />
      <div className='logout-modal-title'>My Account</div>
      <div className='logout-modal-title-stub-long' />
      <div className='logout-modal-title-question'><img className='logout-modal-account' src='/assets/account_white.svg'/></div>
      <div className='logout-modal-title-stub-short' />
    </div>
  );
};

const LogoutModal = () => {
  const { accountAddress, setWalletAddress, setArWalletAddress, setAccountAddress, setShowLogout } = useContext(AppContext);
  const { disconnect } = useDisconnect();
  const { address: connectedWalletAddress } = useAccount();
  const [isDisabled, setIsDisabled] = useState(false);
  const [removedWallets, setRemovedWallets] = useState([]);

  const navigate = useNavigate();
  const myLocation = useLocation();
  const { user, logout: discordTokenLogout, basejumpToken } = useTokenAuth();
  const { connected: isArweaveConnected, connect: connectArweave, disconnect: _disconnectArweave } = useConnection();
  const activeArweaveAddress = useActiveAddress();
  const { connectors, connect } = useConnect();
  const connector = connectors.find((c) => c.name.includes('Immutable Passport'));

  const onClickLogout = async () => {
    setIsDisabled(true);
    try {
      discordTokenLogout();
      disconnect();
      //Disconnect seems to be not really needed
      //disconnectArweave();
      await passportInstance.logout();
    } catch (error) {
      console.error(error);
      console.warn('Failed to logout');
    }
    setAccountAddress(null);
    setWalletAddress(null);
    setShowLogout(false);
    setIsDisabled(false);
    if (myLocation.pathname === '/app') {
      navigate('/home');
    }
  }
  
  const { open: openWalletPopup } = useWeb3Modal();

  const onClickConnect = () => {
    if (connectedWalletAddress) {
      setWalletAddress(connectedWalletAddress);
    } else {
      openWalletPopup();
    }
  };

  const onClickConnectArweave = async () => {
    if (activeArweaveAddress) {
      setArWalletAddress(activeArweaveAddress);
    } else {
      await connectArweave();
    }
  };
  
  const onClickConnectPassport = async () => {
    connect({ connector });
  };

  const deleteWallet = (wallet) => {
    const { address } = wallet;
    setRemovedWallets([...removedWallets, address]);
    removeUserWallets(basejumpToken, [wallet])
      .catch((error) => console.error(error));
  };

  const passportWallets = user?.wallets.filter((w) => w.sub_type === 'passport' && !removedWallets.includes(w.address));
  const evmWallets = user?.wallets?.filter((w) => w.type === 'evm' && w.sub_type !== 'passport' && !removedWallets.includes(w.address));
  const wanderWallets = user?.wallets?.filter((w) => w.type === 'wander' && !removedWallets.includes(w.address));

  return (
      <StyledLogoutModal>
        <div className='logout-modal-all'>
        <LogoutTitle />
        <div className='logout-modal'>
          <div className='logout-modal-moonpay-holder'>
            <div className='logout-modal-question-decorator'/>
            <div className='logout-modal-content'>
              <div className='logout-modal-moonpay'>
                <div className='logout-modal-address'>
                  <div>{accountAddress}</div>
                  <img className='logout-modal-account' src='/assets/done_green.svg'/>
                </div>
                <div className='logout-modal-wallet-list'>
                {passportWallets && passportWallets.map((w) => {
                  return ( 
                    <div className='logout-modal-address'>
                      <div>{composeShortAddress(w.address)}</div>
                      <div className='logout-modal-address-controls'>
                        <img className='logout-modal-account' src='/assets/immutable_white.svg'/>
                        <img className='logout-modal-account logout-delete-button' onClick={() => deleteWallet(w)} src='/assets/trash.svg'/>
                      </div>
                    </div>
                  );
		})}
                {evmWallets && evmWallets.map((w) => {
                  return ( 
                    <div className='logout-modal-address'>
                      <div>{composeShortAddress(w.address)}</div>
                      <div className='logout-modal-address-controls'>
                        <img className='logout-modal-account' src='/assets/eth.svg'/>
                        <img className='logout-modal-account logout-delete-button' onClick={() => deleteWallet(w)} src='/assets/trash.svg'/>
                      </div>
                    </div>
                  );
		})}
                {wanderWallets && wanderWallets.map((w) => {
                  return (
                    <div className='logout-modal-address'>
                      <div>{composeShortAddress(w.address)}</div>
                      <div className='logout-modal-address-controls'>
                        <img className='logout-modal-account' src='/assets/wander_logo.svg'/>
                        <img className='logout-modal-account logout-delete-button' onClick={() => deleteWallet(w)} src='/assets/trash.svg'/>
                      </div>
                    </div>
                  );
                })}
                </div>
                  <IconButton
                    animated={true}
                    backgroundOverwrite='white'
                    borderOverwrite='rgba(0, 0, 0, .16)'
                    borderOverwriteHover='rgba(0, 0, 0, .32)'
                    onClick={onClickConnectPassport}>
                    <div className='connect-wallet-button-content'>
                      <div>Connect Passport</div>
                      <img style={{paddingBottom: '6px', width: '2.5rem', height: '2.5rem' }} src='/assets/immutable.svg'/>
                    </div>
                  </IconButton>
                  <IconButton onClick={onClickConnectArweave}>
                    <div className='connect-wallet-button-content'>
                      <div>Connect Wander Wallet</div>
                      <img style={{paddingBottom: '6px', width: '2.5rem', height: '2.5rem' }} src='/assets/ww.svg'/>
                    </div>
                  </IconButton>
                  <IconButton
                    onClick={onClickConnect}
                    animated={true}
                    borderOverwrite='rgba(0, 0, 0, .16)'
                    borderOverwriteHover='rgba(0, 0, 0, .32)'
                    backgroundOverwrite={theme.baseGreen}>
                    <div className='connect-wallet-button-content'>
                      <div>Connect Wallet</div>
                      <img style={{paddingBottom: '6px'}} src='/assets/wallet.svg'/>
                    </div>
                  </IconButton>
                <IconButton onClick={onClickLogout} animated={true} disabled={isDisabled} backgroundOverwrite='#DD5460'>
                  <div className='connect-wallet-button-content'>
                    <div>Log Out</div>
                    <img style={{paddingBottom: '6px'}} src='/assets/logout.svg'/>
                  </div>
                </IconButton>
              </div>
            </div>
          </div>
        </div>
        <div className='logout-corner logout-corner-tl' />
        <div className='logout-corner logout-corner-tr' />
        <div className='logout-corner logout-corner-bl' />
        <div className='logout-corner logout-corner-br' />
        </div>
      </StyledLogoutModal>
  );
};

export default LogoutModal;
